import {
  AddWorkScheduleCommand,
  WorkScheduleListParams,
} from "@/models/club";
import clubRequest from "../axios";

const getShiftSchedule = async (params: WorkScheduleListParams) =>
  (await clubRequest.workScheduleList(params)).data;

const createShiftSchedule = async (data: AddWorkScheduleCommand) =>
  (await clubRequest.workScheduleCreate(data)).data;

export { getShiftSchedule, createShiftSchedule };
